import React, { Component } from 'react';
import axios from 'axios';
import moment from 'moment';
import ActionButton from '../../common/ActionButton';
import { getCSRFToken, ROOT_URL } from '../../../config';
import { getErrorMessages } from '../../../utils';
import { ErrorMessage } from '../../common';
import { TPageNotification } from '../../../types';


type ConfirmUpdateInductionSessionProps = {
    notification: TPageNotification;
    closeModal: () => void;
    eventInfo: any;
    reloadData: () => void;
}

type ConfirmUpdateInductionSessionState = {
    error: any;
}

export class ConfirmUpdateInductionSession extends Component<
    ConfirmUpdateInductionSessionProps,
    ConfirmUpdateInductionSessionState
> {
    state = {
        error: '',
    }

    updateSessionDateOnDrag = ()=> {
        const { eventInfo } = this.props;

        const eventId = eventInfo.event.id;
        const headers = {
            'X-CSRFToken': getCSRFToken(),
        };
        // Update start date and time of induction session
        axios.patch(
            `${ROOT_URL}induction-sessions/${eventId}/`,
            { start: eventInfo.event.start },
            { headers }
        )
            .then((response => {
                const content = response.data?.content;
                this.props.notification.success(
                    'Success', 'Session has been rescheduled successfully.'
                );
                this.props.closeModal();
                this.props.reloadData();
                return content;
            }))
            .catch(error => {
            if (error && error.response) {
                    this.setState({ error: getErrorMessages(error) });
                }
        });

        };

    render() {
        const updatedDateTime = moment(this.props.eventInfo.event.start.toString());
        const confirmationText = updatedDateTime.format('DD/MM/YYYY hh:mm A');

        return (
            <div className="cancel-shift">
                <div className="popup-header">
                    <div
                        className="popup-header-dismiss"
                        onClick={this.props.closeModal}
                    >
                        <i className="icon icon-close" />
                    </div>
                    <h1>
                        Reschedule induction session
                    </h1>
                </div>
                <div>
                    Are you sure you want to reschedule the induction session to <b>{confirmationText}</b>?
                </div>
                <div className="modal-bottom-bar">
                    <ActionButton
                        onAction={this.updateSessionDateOnDrag}
                        text="Confirm"
                        className="confirm"
                    />
                    <ActionButton
                        onAction={this.props.closeModal}
                        text="Cancel"
                        className="cancel"
                    />
                </div>
                {this.state.error ? (
                    <ErrorMessage message={this.state.error} />
                ) : false}
            </div>
        );
    }
}
